import { Loader2, PlayIcon } from "lucide-react";
import posthog from "posthog-js";

interface ChatQuizCardProps {
	isLoading?: boolean;
	onStart: () => void;
}

const ChatQuizCard = ({ isLoading, onStart }: ChatQuizCardProps) => {
	return (
		<div className="flex w-full flex-col gap-3 rounded-2xl border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-700 dark:bg-slate-800">
			<div className="flex items-center gap-3">
				<div className="flex size-10 items-center justify-center rounded-full bg-sky-100 text-sky-600 dark:bg-sky-900/30 dark:text-sky-400">
					{isLoading ? (
						<Loader2 className="size-5 animate-spin" />
					) : (
						<PlayIcon className="size-5" />
					)}
				</div>
				<div>
					<h4 className="font-semibold text-slate-900 dark:text-white">
						Practice Quiz
					</h4>
					<p className="text-slate-500 text-xs dark:text-slate-400">
						{isLoading ? "Generating questions..." : "Test your knowledge"}
					</p>
				</div>
			</div>
			<button
				type="button"
				onClick={() => {
					posthog.capture("quiz:attempt_clicked");
					onStart();
				}}
				disabled={isLoading}
				className="w-full rounded-xl bg-slate-900 py-2.5 font-medium text-sm text-white hover:bg-slate-800 disabled:opacity-50 dark:bg-white dark:text-slate-900 dark:hover:bg-slate-100"
			>
				{isLoading ? "Generating..." : "Start Quiz"}
			</button>
		</div>
	);
};

export default ChatQuizCard;
